import { FAQItem } from "domain/payload/response/faq/FAQResp";
import React, { useEffect, useMemo, useState } from "react";
import FAQService from "service/FAQService";

const FAQPage: React.FC = () => {
  const [faqList, setFaqList] = useState<FAQItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqService = FAQService();

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    try {
      setLoading(true);
      const response = await faqService.getFAQList();
      setFaqList(response.data ?? []);
    } catch (e) {
      console.error("Error fetching FAQ:", e);
    } finally {
      setLoading(false);
    }
  };
  
  const filteredFaqs = useMemo(() => {
    if (!search) return faqList;

    return faqList.filter((faq) =>
      faq.title.toLowerCase().includes(search.toLowerCase()) ||
      faq.body.toLowerCase().includes(search.toLowerCase())
    );
  }, [faqList, search]);

  return (
    <div className="container bg-white rounded-top pb-5">
      <input
        type="text"
        className="form-control mt-3 mb-3"
        placeholder="Search"
        style={{ height: 50 }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" />
        </div>
      )}

      {!loading && (
        <div>
          {filteredFaqs.map((faq, index) => {
            const isOpen = index === openIndex;

            return (
              <div
                key={index}
                className="card mb-3 border"
                style={{ borderColor: "#e0e0e0" }}
              >
                <button
                  className="card-body d-flex justify-content-between align-items-center w-100 text-start"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  style={{ background: "transparent", border: "none" }}
                >
                  <span className="fw-semibold">
                    {faq.title}
                  </span>

                  <span style={{ fontSize: 22 }}>
                    {isOpen ? "▴" : "▾"}
                  </span>
                </button>

                {isOpen && (
                  <div
                    className="px-3 pb-3 text-muted small"
                    style={{ marginTop: "-10px" }}
                    dangerouslySetInnerHTML={{ __html: faq.body }}
                  />
                )}
              </div>
            );
          })}

          {filteredFaqs.length === 0 && (
            <div className="text-center text-muted mt-4">
              FAQ tidak ditemukan
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FAQPage;